// helpers/wallet.js

import axios from "axios";

/* ======================================================
   GET WALLET BALANCE
====================================================== */

export const fetchWalletBalance =
  async () => {

    try {

      const res =
        await axios.get(
          "/api/wallet/balance",
          {
            withCredentials: true,
          }
        );

      return res.data;

    } catch (err) {

      throw (
        err?.response?.data ||
        err
      );

    }

  };

  /* ======================================================
   GET GHSX WALLET BALANCE
====================================================== */

export const fetchGhsxWalletBalance =
  async () => {

    try {

      const res =
        await axios.get(
          "/api/wallet/ghsx/balance",
          {
            withCredentials: true,
          }
        );

      return res.data;

    } catch (err) {

      throw (
        err?.response?.data ||
        err
      );

    }

  };